import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

type OptOutApi = () => unknown;

export function DoNotSell() {
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);
  const [gpc, setGpc] = useState(false);

  useEffect(() => {
    setGpc(!!(navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl);
  }, []);

  function optOut() {
    const api = (window as unknown as { eftOptOutSale?: OptOutApi }).eftOptOutSale;
    if (typeof api !== 'function') {
      setError(true);
      return;
    }
    api();
    setDone(true);
  }

  return (
    <section className="section">
      <div className="container privacy-page">
        <div className="section-head reveal">
          <p className="eyebrow">Legal</p>
          <h1>Do Not Sell or Share My Personal Information</h1>
        </div>

        <div className="privacy-body reveal reveal-delay-1">
          <p>
            Under the California Consumer Privacy Act (CCPA), "selling" personal information includes
            selling, renting, releasing, disclosing, disseminating, making available, transferring, or
            otherwise communicating personal information to a third party for monetary or other valuable
            consideration. "Sharing" includes disclosing personal information for cross-context behavioral
            advertising.
          </p>
          <p>
            Expanse Financial Technologies, Inc. does not sell your personal information for monetary
            consideration, and we do not share your personal information for cross-context behavioral
            advertising. The button below records an opt-out preference for this browser so that, if our
            practices ever change, your choice is already on file.
          </p>

          {gpc && (
            <p className="dns-gpc-note">
              We detected a Global Privacy Control signal from your browser. Your opt-out is already
              recorded for this browser, but you can still click the button below to confirm.
            </p>
          )}

          <div className="dns-action">
            {done ? (
              <p className="dns-confirm" role="status">
                Your opt-out preference has been recorded for this browser. You may need to repeat this
                choice on other devices or browsers.
              </p>
            ) : (
              <>
                <button type="button" className="btn btn-primary" onClick={optOut}>
                  Opt me out of sale and sharing
                </button>
                {error && (
                  <p className="dns-error" role="alert">
                    We could not record your opt-out right now. Please reload the page and try again, or
                    email us at <a href="mailto:privacy@expanseft.com">privacy@expanseft.com</a>.
                  </p>
                )}
              </>
            )}
          </div>

          <p>
            For full details on how we handle information, see our <Link to="/privacy">Privacy Policy</Link>.
            To adjust your cookie categories, use the "Cookie Settings" link in the Site footer.
          </p>
        </div>
      </div>
    </section>
  );
}
